import type { FaireProductEntity } from "../../entity_types/product";

export const p_ymq2dk6syf: FaireProductEntity = {
  token: "p_ymq2dk6syf",
  type: "product",
  name: "High Vibrational Handmade Tibetan Singing Bowl Small Travel Size",
  brandToken: "b_9jg4fbzgpg",
  brandName: "Like International",
  imageUrl: "https://cdn.faire.com/fastly/628e99f6429ce6d364a94cad32d949cd337951a868c0bc222fa8442c4e0fad4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d5547b9747b28dc76b9493d303a9cf2586458787430dbe01a00c93873bf20edf.jpeg",
    "https://cdn.faire.com/fastly/aabaf9ce940a29db4c85e6d0bd98a923cbdedbb340316e3972ccd4a3ec20ae7a.jpeg",
    "https://cdn.faire.com/fastly/23e96e077eee50c389981d3b464fda0ccb45d51ad64ba929f350e0ce1c095810.jpeg",
    "https://cdn.faire.com/fastly/26273a5c73193b4912321191dfb234e0e06b212d5d7e5b551570ac598d3523d8.jpeg",
    "https://cdn.faire.com/fastly/9cf60af34f445d898a69dcfa06cf80050ed1f7a1c92bc499deab1b449e86b8e5.jpeg",
    "https://cdn.faire.com/fastly/17c837cd7163ad86e49423696d14f615559af4f306401a8187b56223b199794a.jpeg",
    "https://cdn.faire.com/fastly/2c56ad1108c26936eb76bf8abd913161b47ff9670e69980c9878f7ba642d97ef.jpeg"
  ],
  priceDollars: 19,
  description: "Meet our Travel-Size Handmade Singing Bowl. Being one of our customer favorites, it makes the perfect singing bowl for beginners as well as experienced players.\n\nHELPFUL DETAILS:\n♥ 3-inch Diameter\n♥ Ideal for meditation, relaxation, yoga, sound therapy, or even to use in classrooms\n♥ Scroll to read about the Health Benefits of Singing Bowls!\n♥ Comes with Singing Bowl and Mallet\n♥ Vibrations from Singing Bowls + Your Brain Waves = Detect Vibrational Imbalances and Soothe Stress\n♥ Gorgeous Antique-Looking Gold Color\n♥ Simple but Elegant with the Hand-Hammered Design (Zoom in for a closer look!)\n♥ Perfect as a gift for your loved ones\n♥ Made of the Harmonious Mixture of 7 Different Metals (Copper, Tin, Zinc, Iron, Nickel, Silver, Gold)\n♥ Play by Striking Once OR Rotate around the Rim\n\nAlthough this singing bowl is at an adorable size of 3.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:13.989Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
